export enum AttributeVisibility {
  None = 0,
  Vendor = 1,
  Public = 2,
}
